(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationTextSettings',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// if "send texts" is changed, either check all or uncheck all recipients
		$('.send-texts-radio').on('change', function _onChange(e) {
			var $self   = $(this),
			    val     = parseInt($self.val()),
			    $recips = $self.parents('.box').find('.text-recipient');

			$recips.prop('checked', val);
		});
	};
}(jQuery, window.Adzuki || {}));
